import { render, staticRenderFns } from "./CrudLabel.vue?vue&type=template&id=6a580ea2"
import script from "./CrudLabel.vue?vue&type=script&lang=js"
export * from "./CrudLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports